module.exports = __webpack_public_path__ + "img/iosAction.efb20889.png";